import { highlightPhrases } from "../helpers";

const ContentUsers = ({ dataUser }) => {
  const phrasesToBold = [
    "host live sessions",
    "Notify your audience",
    "talk directly with your listeners",
    "Schedule your live sessions and notify your audience",
    "Chat with your followers in real-time, and build your brand with every live session",
    "you can tune into personalized frequencies and explore a rich variety of voices and sounds",
    "Chat with your favorite creators, ask questions, and get exclusive insights into their creative process",
  ];
  return (
    <main className="content-users-wrapper ">
      {Object.entries(dataUser).map(([key, value], index) => {
        // left col content
        if (key === "sectionLeft") {
          return (
            <section
              className="content-users-wrapper__left-col"
              key={`${key}-${index}`}
            >
              {value.content.map((contentItem, indexItem) => {
                return (
                  <div
                    key={`leftcol-${indexItem}`}
                    style={{ position: "relative" }}
                  >
                    <div className="content-users-wrapper__left-col__overlay"></div>
                    <h2 className="content-users-wrapper__left-col__title">
                      {contentItem.content}
                    </h2>
                  </div>
                );
              })}
            </section>
          );
        }

        // right col content
        if (key === "sectionRight") {
          return (
            <section
              className="content-users-wrapper__right-col"
              key={`${key}-${index}`}
            >
              {value.content.map((contentItem, indexItem) => {
                if (Array.isArray(contentItem.content)) {
                  // returns pictures
                  return (
                    <div
                      key={`${key}-${contentItem.tag}-${indexItem}`}
                      className={
                        contentItem.tag === "img"
                          ? "content-users-wrapper__right-col__img"
                          : "content-users-wrapper__right-col__text"
                      }
                    >
                      {contentItem.content.map(
                        (nestedItem, nestedItemIndex) => {
                          if (nestedItem.tag === "img") {
                            return (
                              <picture
                                key={`${key}-picture-${nestedItemIndex}`}
                              >
                                {nestedItem.sources.map((source, idx) => (
                                  <source
                                    key={idx}
                                    media={source.media}
                                    sizes={source.sizes}
                                    srcSet={source.srcSet
                                      .map(
                                        (item) => `${item.src} ${item.width}`,
                                      )
                                      .join(", ")}
                                  />
                                ))}
                                <img
                                  loading="lazy"
                                  src={nestedItem.fallback}
                                  alt={nestedItem.altImg}
                                />
                              </picture>
                            );
                          }
                          return (
                            <p
                              key={`${key}-${nestedItem.tag}-${nestedItemIndex}`}
                            >
                              {highlightPhrases(
                                nestedItem.content,
                                phrasesToBold,
                              )}
                            </p>
                          );
                        },
                      )}
                    </div>
                  );
                }
                // returns quote
                return (
                  <div
                    className="content-users-wrapper__right-col__quote"
                    key={`${key}-${contentItem.tag}-${indexItem}`}
                  >
                    <h3 key={index}>{contentItem.content}</h3>
                  </div>
                );
              })}
            </section>
          );
        }
        return null;
      })}
    </main>
  );
};

export default ContentUsers;
